import { jsx as _jsx } from "react/jsx-runtime";
import { m } from 'framer-motion';
import clsx from 'clsx';
import { opacityAnimation } from '../animation/opacity-animation';
export function Underlay({ position = 'absolute', className, isTransparent = false, disableInitialTransition, ...domProps }) {
    return (_jsx(m.div, { ...domProps, className: clsx(className, !isTransparent && 'bg-background/80', 'inset-0 z-10 h-full w-full', position, 'backdrop-blur-sm'), "aria-hidden": true, initial: disableInitialTransition ? undefined : { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, ...opacityAnimation, transition: { duration: 0.15 } }));
}
